/**
 * Prospect TypeScript types — Feature 041
 * Matches Cre8or.Crm.Admin.Api DTOs
 */

export type ProspectStatusValue = 1 | 2 | 3; // 1=Prospect, 2=Closed, 3=Qualified

export const PROSPECT_STATUS_LABELS: Record<number, string> = {
  1: 'Prospect',
  2: 'Closed',
  3: 'Qualified',
};

export interface Prospect {
  prospectId: string;
  leadId: string;
  leadInternalId: string;
  subject: string;
  accountId: string | null;
  companyName: string;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  leadSource: string | null;
  priority: string;
  status: ProspectStatusValue;
  ownerUserId: string | null;
  ownerDisplayName: string | null;
  createdBy: string;
  createdByDisplayName: string | null;
  createdAt: string;
  updatedAt: string;
  /** Presigned S3 URL — valid for PDF_PRESIGN_TTL_MINUTES */
  pdfUrl: string;
  pdfOriginalFilename: string;
  /** External URL alternative to PDF */
  linkUrl?: string | null;
}

export interface ProspectListItem {
  prospectId: string;
  leadId: string;
  leadInternalId: string;
  subject: string;
  accountId: string | null;
  companyName: string;
  leadSource: string | null;
  status: number;
  priority: number;
  ownerUserId: string | null;
  ownerDisplayName: string | null;
  customerResponded: boolean;
  isUnread?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProspectListResponse {
  items: ProspectListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface ProspectFilterOptions {
  companyNames: string[];
  owners: string[];
  subjects: string[];
}
